import { render, staticRenderFns } from "./probability-header-pre.vue?vue&type=template&id=cb9dd1b4&"
import script from "./probability-header-pre.vue?vue&type=script&lang=js&"
export * from "./probability-header-pre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports